import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';

const CTASection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Image - Construction Blueprints */}
      <div className="absolute inset-0 w-full">
        <img
          src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2000&q=80"
          alt="Construction blueprints"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/95 to-cyan-700/90" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-10">
            Ready to Build?<br />
            Let's Make Your Dream a Reality
          </h2>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/consultation">
              <Button
                size="lg"
                className="bg-white text-cyan-700 hover:bg-slate-100 font-semibold px-8 py-6 text-lg group"
              >
                Request Consultation
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <a href={`tel:${companyInfo.phone}`}>
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg"
              >
                <Phone className="mr-2 w-5 h-5" />
                Call Us Now
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
